import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    showAlert: false,
    alertType: null,
    alertMessage: null,
    alertContext: null
};

const alertSlice = createSlice({
    name: 'alert',
    initialState,
    reducers: {
        setShowAlert: (state, action) => {
            console.log("Setting alert:", action.payload);
            state.showAlert = true;
            state.alertType = action.payload.type;
            state.alertMessage = action.payload.messages;
            state.alertContext = action.payload.context;
        },
        hideAlert: (state, action) => {
            if (!action.payload) {
                console.log("Hiding alert");
                state.showAlert = false;
                state.alertType = null;
                state.alertMessage = null;
                state.alertContext = null;
            } else if (state.alertContext === action.payload.context) {
                console.log("Hiding alert");
                state.showAlert = false;
                state.alertType = null;
                state.alertMessage = null;
                state.alertContext = null;
            }
        }
    }
});

export const { setShowAlert, hideAlert } = alertSlice.actions;
export default alertSlice.reducer;